export const GOOGLE_RECAPTCHA_KEY = "6LewpSgsAAAAABG12oAoaViMuEmDOkvZYj5lAL_d";